var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 482.1 482.1",
    style: {
      enableBackground: "new 0 0 482.1 482.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{stroke:#000000;stroke-width:10;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M125.8,408L125.8,408"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M404,91c21.4,0,38.7,17.3,38.7,38.7v213.5c0,21.4-17.3,38.7-38.7,38.7H74c-21.4,0-38.7-17.3-38.7-38.7V129.7 C35.3,108.3,52.6,91,74,91H404z M404,103.7H74c-14.3,0-26,11.7-26,26v213.5c0,14.3,11.7,26,26,26H404c14.3,0,26-11.7,26-26V129.7 C430,115.4,418.3,103.7,404,103.7L404,103.7z M239,129.8c58.9,0,106.6,47.7,106.6,106.6S297.9,343.1,239,343.1 s-106.6-47.7-106.6-106.6S180.1,129.8,239,129.8L239,129.8z M239,142.6c-51.9,0-93.9,42-93.9,93.9s42,93.9,93.9,93.9 s93.9-42,93.9-93.9S290.9,142.6,239,142.6L239,142.6z M206.5,181.6h0.8c1.9,0.5,1.2,0.2,2.4,0.8l84.1,48.5c4.2,2.4,4.2,8.6,0,11 l-84.1,48.5c-4.2,2.4-9.5-0.6-9.5-5.5v-97.1c0.1-3.1,2.3-5.8,5.4-6.3H206.5z M213,199v75l65-37.6L213,199z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoIcon);
export default __webpack_public_path__ + "static/media/video-icon.deb23980e868e48b17241fa9aac10485.svg";
export { ForwardRef as ReactComponent };